export const theme = {
	token: {
		colorPrimary: '#3F78E0',
		colorOppositePrimary: '#FFFFFF',
		colorPrimaryActive: '#3F78E0',
		colorPrimaryHover: '#3F78E0',
		colorLink: '#3F78E0',
		colorLinkActive: '#2d4ffc',
		colorLinkHover: '#3F78E0',
		colorError: '#cf5d60',
		fontFamily: `'Roboto', Arial, sans-serif`,
		colorBgContainer: '#fff',
		colorTextHeading: '#0A2540',
	},
	components: {
		Tooltip: {
			fontSize: 12
		},
		Table: {
			colorBorderSecondary: '#7169fb33',
			colorText: '#0A2540',
			colorBgContainer: 'transparent'
		},
		Modal: {
      colorText: '#0A2540',
			colorBgMask: 'rgba(0,0,0, 0.1)',
			colorPrimaryBorder: 'rgba(10,37,64,.1)',
			borderRadiusLG: 20,
			boxShadow: '0 20px 30px rgba(0,0,0,.05)',
		},
		Checkbox: {
			borderRadiusSM: 10
		}
	}
}
